import { InternationalStringDTO, SeatDTO, TripCustomizationDTO, TripDTO } from "../../apiclient/ApiDtos"
import { TripSelectedFsmContext } from "../trip-selected/TripSelectedFsmContext"

export class SeatReservationFsmContext {
    constructor(
        public readonly tripSelectedContext: TripSelectedFsmContext,
        public readonly tripDetails: TripDTO|null,
        public readonly selectedSeats: SeatDTO[] = [],
        public readonly errorMessage?: InternationalStringDTO | null,
        public readonly tripCustomization?: TripCustomizationDTO
    ) { }

    withTripDetails(tripDetails: TripDTO): SeatReservationFsmContext {
        return new SeatReservationFsmContext(this.tripSelectedContext, tripDetails, this.selectedSeats, this.errorMessage, this.tripCustomization)
    }

    withSelectedSeats(selectedSeats: SeatDTO[]) {
        return new SeatReservationFsmContext(this.tripSelectedContext,  this.tripDetails, selectedSeats, this.errorMessage)
    }

    withTripDetailsFetchingError(errorMessage: string): SeatReservationFsmContext {
        return { ...this, errorMessage: errorMessage }
    }

    withTripCustomization(tripCustomization: TripCustomizationDTO) {
        return new SeatReservationFsmContext(
            this.tripSelectedContext, this.tripDetails, this.selectedSeats,  this.errorMessage,
            tripCustomization)
    }
    
    cancelTripCustomization() {
        return new SeatReservationFsmContext(
            this.tripSelectedContext, null, [],  null,
            undefined)
    }

    withError(errorMessage: InternationalStringDTO) {
        return new SeatReservationFsmContext(
            this.tripSelectedContext, this.tripDetails, [], errorMessage
        )
    }
}

